import React, { Component } from "react";
import Menu from "./menu";

import "./css/about.css";

import photoBoothPNG from "./images/about/photo_booth.png";

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="about-page">
        <Menu />
        <div className="intro section-wrapper">
          <div className="section">
            <img src={photoBoothPNG} alt="Mihai Cernusca" />
            <div className="flex-grid">
              <div className="seventy-column">
                <h1>Hi there,</h1>
                <p>
                  As a multidisciplinary professional, my strength lies in bringing new ideas to life from concept
                  through to execution. I'm particularly interested in working on{" "}
                  <a href="https://www.are.na/mihai-cernusca/www-os" target="_blank" rel="noopener noreferrer">
                    rich web-based
                  </a>{" "}
                  tools as part of small{" "}
                  <a href="https://www.are.na/mihai-cernusca/tools-craft" target="_blank" rel="noopener noreferrer">
                    motivated
                  </a>{" "}
                  teams.
                </p>
                <p>
                  Currently part of the Core Experience team at{" "}
                  <a href="https://perplexity.ai" target="_blank" rel="noopener noreferrer">
                    Perplexity
                  </a>
                  .
                </p>
                <p>
                  Previously, I helped shape next-generation creative tools at{" "}
                  <a href="https://visualelectric.com" target="_blank" rel="noopener noreferrer">
                    Visual Electric
                  </a>
                  , explored making an impact in the real world with <a href="/flexhouse">Flexhouse</a>, worked on
                  machine-assisted ideation tools at <a href="/re-collect">re:collect</a>, helped{" "}
                  <a href="/whereby">Whereby</a> rebuild their core meetings product, and mused about web-native
                  presentations at <a href="/swipe">Swipe</a>. Earlier, I crafted dozens of apps during the App Store's
                  heyday. In a previous life, I{" "}
                  <a href="https://2008.mihaicernusca.com" target="_blank" rel="noopener noreferrer">
                    studied computer animation
                  </a>
                  .
                </p>
                <p>
                  To learn more please <a href="/mihai-cernusca-resume.pdf">check my resume</a>.
                </p>
                <p>
                  If you find any of this interesting, I'd love to hear from you:{" "}
                  <a href="mailto:mcernusca@gmail.com" target="_blank" rel="noopener noreferrer">
                    mcernusca@gmail.com
                  </a>
                </p>
              </div>
            </div>
            {/* 
            <h2>Experience</h2>
            <div className="resume">
              <div className="cell">
                <h3>Co-founder, Flexhouse</h3>
                <p className="date">2024</p>
                <p className="description">
                  We believe everyone should have control over their physical surroundings, and that part of the problem
                  lies in the design tooling. I built a series of prototypes to explore and communicate the concept of a
                  new type of residential design tool—one that enables experimentation without cost penalties. The tool
                  works within a system of real-world constraints, offering instant feedback on the impact of changes.
                </p>
                <p className="description">
                  To learn more <a href="/flexhouse">view the case study</a>.
                </p>
                <div className="tags">
                  <span>Product design</span>
                  <span>Prototyping</span>
                  <span>React Three Fiber</span>
                  <span>Three.js</span>
                  <span>Typescript</span>
                </div>
              </div>
              <div className="cell">
                <h3>Founding Product Designer / Engineer, re:collect</h3>
                <p className="date">2021—24</p>
                <p className="description">
                  I helped re:collect design and build their first product: a browser extension that automatically
                  collects content as you interact with the web and a web based ideation tool that leverages machine
                  learning to help you effortlessly find and make use of stored insights without breaking flow.
                </p>
                <p className="description">(Acquired by SmartNews in 2024)</p>
                <p className="description">
                  To learn more <a href="/re-collect">view the case study</a>.
                </p>
                <div className="tags">
                  <span>Product design</span>
                  <span>React</span>
                  <span>Prototyping</span>
                  <span>Python</span>
                  <span>Postgres</span>
                </div>
              </div>
              <div className="cell">
                <h3>Senior Product Designer / Engineer - Core Product, Whereby</h3>
                <p className="date">2019—21</p>
                <p className="description">
                  Worked on core meeting experience with a small remote team. I was a key player in{" "}
                  <a
                    href={
                      "https://medium.com/the-making-of-whereby/https-medium-com-whereby-see-what-were-bringing-to-whereby-in-the-coming-weeks-76d7d810fd6f"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    rebuilding the web client
                  </a>{" "}
                  and features like{" "}
                  <a
                    href={"https://www.producthunt.com/posts/picture-in-picture-by-whereby"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Picture-in-Picture
                  </a>
                  , the{" "}
                  <a
                    href={"https://www.producthunt.com/posts/xl-video-rooms-in-whereby"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    XL room experience
                  </a>{" "}
                  and{" "}
                  <a
                    href={"https://www.producthunt.com/posts/breakout-groups-by-whereby"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Breakout Groups
                  </a>
                  .
                </p>
                <p>
                  Designed, prototyped and articulated core product vision around themes like: trust,{" "}
                  <a href={"https://whereby.com/blog/combat-video-fatigue"} target="_blank" rel="noopener noreferrer">
                    directing attention
                  </a>
                  ,{" "}
                  <a
                    href={"https://whereby.com/blog/how-whereby-is-making-remote-collaboration-easier-than-ever"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    collaboration
                  </a>
                  , solving the large meeting participation problem, transforming rooms, automation, planning,
                  personalization and more.
                </p>
                <p className="description">
                  To learn more <a href="/whereby">view the case study</a>.
                </p>
                <div className="tags">
                  <span>Product design</span>
                  <span>React</span>
                  <span>Prototyping</span>
                  <span>Node</span>
                  <span>Redis</span>
                </div>
              </div>

              <div className="cell">
                <h3>Freelance Designer / Developer, Various Clients</h3>
                <p className="date">2016—19</p>
                <p className="description">
                  Worked on a broad range of projects with{" "}
                  <a href="http://www.hyperakt.com/" target="_blank" rel="noopener noreferrer">
                    Hyperakt
                  </a>
                  , Tech City UK , Weav Music , Jaguar Land Rover, EY and more.
                </p>
                <div className="tags">
                  <span>Product design</span>
                  <span>React</span>
                  <span>Swift</span>
                  <span>Go</span>
                </div>
              </div>

              <div className="cell">
                <h3>Founding Product Designer / Engineer, Swipe Tech Limited</h3>
                <p className="date">2014—16</p>
                <p className="description">
                  Made sharing and presenting better with a small London based team. Designed v2 of the product and
                  migrated the application front-end from Backbone to React. Prototyped new features and products. Set
                  best practices and mentored junior developers.
                </p>
                <p className="description">(Acquired by Whereby in 2019)</p>
                <p className="description">
                  To learn more <a href="/swipe">view the case study</a>.
                </p>
                <div className="tags">
                  <span>Product design</span>
                  <span>Prototyping</span>
                  <span>React</span>
                  <span>Go</span>
                  <span>Cassandra</span>
                </div>
              </div>

              <div className="cell">
                <h3>Co-founder, GIF SHOP</h3>
                <p className="date">2010—14</p>
                <p className="description">
                  The animated .gif maker for your iPhone. Featured numerous times on the App Store, Wired Magazine
                  Editor’s Pick 2010, FWA Mobile 2010, Gizmodo app of the day and more.{" "}
                  <a href="http://gifshop.tv" target="_blank" rel="noopener noreferrer">
                    (gifshop.tv)
                  </a>
                </p>
                <p className="description">
                  To learn more <a href="/gifshop">view the case study</a>.
                </p>
                <div className="tags">
                  <span>Product design</span>
                  <span>Objective-C</span>
                  <span>PHP</span>
                  <span>MySQL</span>
                </div>
              </div>

              <div className="cell">
                <h3>Technical Designer, MFLUENT LLC</h3>
                <p className="date">2009—14</p>
                <p className="description">
                  Brought mobile visions to life. Lead the design, web and front-end iOS development efforts. Set best
                  practices and built tools to automate design and engineering workflows. Mentored junior designers.
                </p>
                <p className="description">
                  To learn more <a href="/brite">view the BriteIM case study</a>.
                </p>
                <div className="tags">
                  <span>Product design</span>
                  <span>Prototyping</span>
                  <span>Graphic design</span>
                  <span>Objective-C</span>
                  <span>PHP</span>
                  <span>MySQL</span>
                </div>
              </div>

              <div className="cell">
                <h3>Freelance iOS Developer, Mediumrare</h3>
                <p className="date">2012</p>
                <p className="description">
                  Built Setlist - The easiest way to discover local shows using artists in your Rdio collection.{" "}
                  <a href="http://mediumrare.co" target="_blank" rel="noopener noreferrer">
                    (mediumrare.co)
                  </a>
                </p>
                <p className="description">
                  To learn more <a href="/setlist">view the case study</a>.
                </p>
                <div className="tags">
                  <span>Objective-C</span>
                </div>
              </div>

              <div className="cell">
                <h3>Freelance Web Application Developer, Various Clients</h3>
                <p className="date">2005—14</p>
                <p className="description">
                  Developed and maintained bespoke content management solutions, online learning applications for use in
                  distance learning research, a health management and tailored health news engine platform, a real time
                  messaging tool to enable senior citizens to maintain contact with extended families, a social network
                  site for STAB Magazine and more.
                </p>

                <div className="tags">
                  <span>PHP</span>
                  <span>MySQL</span>
                  <span>Go</span>
                  <span>Redis</span>
                </div>
              </div>
            </div>
            <h2>Education</h2>
            <div className="resume">
              <div className="cell">
                <h3>Bachelor of Fine Arts in Media Arts & Animation, The Illinois Institute of Art — Schaumburg</h3>
                <p className="date">2008</p>
                <div className="description">
                  <ul>
                    <li>Hosted workshop: Maxscript for artists, 2008</li>
                    <li>Hosted workshop: Web development for artists, 2008</li>
                    <li>Participant — FJORG! Siggraph 2008</li>
                    <li>Best Team Animation — ARTimation 2008 Digital Arts Festival</li>
                    <li>Visual Voltage (AIGA Student Chapter at ILIS) Webmaster, 2008</li>
                    <li>2nd place — 2005 ILIS High School Senior Scholarship Competition</li>
                    <li>
                      1st place —{" "}
                      <a
                        href="http://www.columbiamissourian.com/news/local/dynamic-duo/article_fc280952-9bbc-5aff-b348-ced1c2f438ab.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        2004 SkillsUSA National 3D Animation Competition
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
               
            </div>
            */}
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/about.js